<div class="container container-input md-button-right" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
  <div  fxFlex="80%">
    <button mat-button class="align-rigth label colored-orange" (click)="getFile()">BAIXAR PLANILHA PADRÃO</button>
  </div>
  <div fxFlex="20%" class=" padding-left">
    <button mat-button color="primary" style="float: right;" class="btn-primary large" (click)="AnexarPlanilha()">ANEXAR PLANILHA</button>
  </div>
</div>
<form #form>
  <input type="file" id="fileUpload" name="fileUpload" multiple="multiple" 
   accept="{{accept}}" style="display:none;"/>
</form>